import { render, staticRenderFns } from "./password.edit.vue?vue&type=template&id=0feb4802"
import script from "./password.edit.vue?vue&type=script&lang=js"
export * from "./password.edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports